// javascriptreact
// file: `src/Components/pages/About.jsx`
import React, { useRef, useState, useEffect } from 'react';
import PageHero from "../pageHero/PageHero_About.jsx";
import Career from "./about/Career.jsx";
import Skills from "./about/Skills.jsx";
import { l } from '../../lang/index.jsx';
import Game from "./about/Game.jsx";
import { supabase } from '../../utils/supabase.js';

export default function About({ lang }) {
    const containerRef = useRef(null);
    const [showGame, setShowGame] = useState(false);
    const [textMap, setTextMap] = useState(null);
    const [careerRows, setCareerRows] = useState(null);
    const [skillsRows, setSkillsRows] = useState(null);

    useEffect(() => {
        Promise.all([
            supabase.from('about_text').select('key, fr, en'),
            supabase.from('about_career').select('lang, position, date, title, content').order('position'),
            supabase.from('about_skills').select('lang, position, group_name, items').order('position'),
        ]).then(([textRes, careerRes, skillsRes]) => {
            if (textRes.data) {
                const map = {};
                textRes.data.forEach(r => { map[r.key] = { fr: r.fr, en: r.en }; });
                setTextMap(map);
            }
            if (careerRes.data) setCareerRows(careerRes.data);
            if (skillsRes.data) setSkillsRows(skillsRes.data);
        });
    }, []);

    const t = (key) => textMap?.[key]?.[lang] || l(key, lang);
    const careerData = careerRows?.filter(r => r.lang === lang).map(r => ({ date: r.date, title: r.title, content: r.content })) ?? null;
    const skillsData = skillsRows?.filter(r => r.lang === lang).map(r => ({ group: r.group_name, items: r.items })) ?? null;

    return (
        <>
            <PageHero lang={lang}/>

            <div key={lang} className="section section-about" ref={containerRef}>
                <div className="about-inner">
                    <div className="about-title">
                        <h2 className="h2">{t('about-title-1')}</h2>
                    </div>
                    <div className="about-content">
                        <p className="reveal-type paragraph" data-bg-color="transparent" data-fg-color="#fcfbe9">
                            {t('about-paragraph-1')}
                        </p>
                    </div>

                    <Career lang={lang} data={careerData}/>

                    <div className="about-title about-skills">
                        <h2 className="h2">{t('about-title-2')}</h2>
                    </div>
                    <div className="about-content">
                        <p className="reveal-type paragraph" data-bg-color="transparent" data-fg-color="#fcfbe9">
                            {t('about-paragraph-2')}
                        </p>
                    </div>

                    <Skills lang={lang} data={skillsData}/>

                    <div className="about-title about-infos">
                        <h2 className="h2">{t('about-title-3')}</h2>
                    </div>
                    <div className="about-content">
                        <p className="reveal-type paragraph" data-bg-color="transparent" data-fg-color="#fcfbe9">
                            {t('about-paragraph-3')}
                        </p>
                    </div>

                    <div className="section section-game">
                        <div className="title-game">
                            <span className="paragraph big-text">{t('game-title')}</span>
                        </div>
                        <button type="button" aria-label="Open the game" className='button' onClick={() => setShowGame(true)}>
                            <span>{t('game-play-btn')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                            </svg>
                        </button>
                        <Game lang={lang} visible={showGame} onClose={() => setShowGame(false)} textMap={textMap} />
                    </div>
                </div>
            </div>
        </>
    );
}